import angular from 'angular';
import common from './common/patient.common';
import modal from './modal/patient.modal';
import providerStatusContent from './provider-status-content/provider-status-content';
import providerStatusHeader from './provider-status-header/provider-status-header';
import doctorList from './doctor-list/doctor-list';
import template from './patient.html';
import { isMobileUISupported } from '../modules/core';
import patientCheckInModalTemplateUrl from './modal/patient.modal.ngtemplate.html';
import reactComponentLoader from '../utility/react-component-loader';
import uuidv4 from 'uuid/v4';
import { PatientSurveyLauncher } from 'common/services/dokbot-service/patient-survey-launcher.class';
import { PatientPauseResolver } from 'common/services/patient-pause-resolver';
import patientCheckInModalService from './modal/common/services/patient-check-in-modal-service';
import { RootScopeEvents } from 'common/services/root-scope-types';
import { PnEvents } from '../realtime';
import * as call from '../modules/call';
import toggleChatBridge from './toggle-chat-bridge/toggle-chat-bridge';
import { VoyceService } from '../modules/extensions-framework/extensions/voyce/voyce-service';
export default angular
    .module('doxy.patient', [
    common,
    modal,
    doctorList,
    providerStatusContent,
    providerStatusHeader,
    reactComponentLoader,
    patientCheckInModalService,
    toggleChatBridge,
])
    .component('patient', {
    template,
    bindings: {
        room: '<',
        currentInstitution: '<',
        roomAdminCanUsePaidFeatures: '<',
        roomAdminPlanType: '<',
    },
    controller: function ($modal, $rootScope, pn, $state, activeComponents, activeStreamService, globalUi, $timeout, trackingFactory, Browser, ModalFactory, VideoProviderFactory, currentUserHelper, updatePatientPageMeta, versionCheckService, patientService, dokbotService, DokbotPatientSurveyService, $stateParams, patientCheckInModalService, notifications, $ngRedux) {
        this.mapStateToThis = (state) => {
            return {
                isSelfPreviewVisible: call.selectors.isSelfPreviewVisible(state),
            };
        };
        this.unsubscribeFromStore = $ngRedux.connect(this.mapStateToThis)(this);
        globalUi.ui.patientCheckIn = true;
        this.pn = pn;
        this.activeComponents = activeComponents;
        const scopeListeners = [];
        new PatientSurveyLauncher($rootScope, DokbotPatientSurveyService, $ngRedux).init();
        if ($stateParams.survey === 'true') {
            DokbotPatientSurveyService.launchDelayedOneIn({
                oneInNumber: 1,
                customDelay: null,
            });
        }
        new PatientPauseResolver($rootScope).init();
        currentUserHelper.institution = this.currentInstitution;
        this.isChatAvailable = () => {
            return activeComponents.chat.canChat();
        };
        this.toggleChat = () => {
            activeComponents.chat.toggleChat();
        };
        this.isMobile = Browser.isMobileScreen();
        this.isIos = Browser.isMobileSafari() || Browser.isIPad();
        this.isDesktop = Browser.getSystemInfo().platform === 'desktop';
        this.ui = globalUi.ui;
        this.activeStreamService = activeStreamService;
        window.addEventListener('resize', () => {
            const isMobile = Browser.isMobileScreen();
            if (this.isMobile !== isMobile) {
                $timeout(() => {
                    this.isMobile = isMobile;
                });
            }
        });
        const resetAndGetUuid = () => {
            trackingFactory.setUserId(uuidv4());
        };
        this.mobileGroupInCall = () => {
            return isMobileUISupported();
        };
        // showClassicCheckInModal will be defined in $onInit after modalScope is created
        // Move binding-dependent operations to $onInit
        let isDoxyBotCheckIn;
        let checkIn;
        let isTOSConfirmed;
        let isAutocheckinPossible;
        const checkSidebarHidden = () => {
            $timeout(() => {
                globalUi.ui.sidebarHidden = Browser.isMobileScreen();
            });
        };
        // Initialize binding-dependent functions and logic in $onInit
        this.$onInit = () => {
            // Update page meta after bindings are available
            if (this.room && this.room.getDisplayName) {
                updatePatientPageMeta(this);
            }
            // Decorate scope after bindings are available
            VideoProviderFactory.decorateScope(this);
            // Now define the binding-dependent functions
            isDoxyBotCheckIn = !$stateParams.autocheckin &&
                this.room.doxyBotCheckIn &&
                dokbotService.isSupported();
            checkIn = () => {
                notifications.closeAll();
                this.patient = {
                    username: $stateParams.username || '',
                };
                this.checkInPromise = patientCheckInModalService
                    .checkIn({
                    room: this.room,
                    patient: this.patient,
                    fromRoomId: $stateParams.fromRoomId,
                })
                    .then(() => {
                    if ($stateParams.transfer) {
                        patientService.notifyTransferSenderAboutSuccessfulTransfer(this.room.id);
                        if (pn.globalState.hasMic &&
                            pn.globalState.hasCamera &&
                            !(pn.globalState.hasMicrophoneAccess &&
                                pn.globalState.hasCameraAccess)) {
                            const activeProvider = VideoProviderFactory.activeProvider;
                            activeProvider.clearCurrentDevices();
                            activeProvider.enableWebcam();
                        }
                        patientService.showSuccessfulTransferToast();
                    }
                });
            };
            isTOSConfirmed = () => {
                if (!this.room.tosURL) {
                    return true;
                }
                const previous = sessionStorage.getItem('TOS') || null;
                return previous === this.room.tosURL;
            };
            isAutocheckinPossible = () => {
                return ($stateParams.autocheckin &&
                    $stateParams.transfer &&
                    !this.room.usePasscode &&
                    isTOSConfirmed());
            };
            // Create modalScope after bindings are available
            const modalScope = $rootScope.$new();
            modalScope.room = this.room;
            modalScope.roomAdminCanUsePaidFeatures = this.roomAdminCanUsePaidFeatures;
            modalScope.currentInstitution = this.currentInstitution;
            // Define showClassicCheckInModal function
            const showClassicCheckInModal = () => {
                if (this.modal)
                    return;
                this.modal = $modal({
                    animation: !Browser.isMobileScreen() && 'am-slide-top',
                    scope: modalScope,
                    contentTemplate: patientCheckInModalTemplateUrl,
                    backdrop: 'static',
                    keyboard: false,
                    prefixEvent: 'patient.modal',
                    prefixClass: 'patient-modal-open modal',
                });
                this.modal.$promise.then((a1, a2) => {
                    $timeout(() => {
                        this.modal.$element.removeAttr('aria-hidden');
                        this.modal.$element.removeAttr('tabindex');
                    });
                });
            };
            // Now execute the modal logic after bindings are available
            ModalFactory.waitForCurrentModalToClose().then(() => {
                if (Browser.isPrerender())
                    return;
                if (!isDoxyBotCheckIn) {
                    if (isAutocheckinPossible()) {
                        checkIn();
                    }
                    else {
                        showClassicCheckInModal();
                    }
                }
                else {
                    dokbotService.initDoxybot(this.room);
                }
            });
        };
        checkSidebarHidden();
        scopeListeners.push($rootScope.$on(RootScopeEvents.CHECK_IN_SUCCESS, () => {
            $timeout(() => {
                if (this.modal) {
                    this.modal.hide();
                    $timeout(() => {
                        this.modal.destroy();
                        this.modal = null;
                    }, 500);
                }
                if (isDoxyBotCheckIn)
                    dokbotService.close();
            }, globalUi.PATIENT_CHECK_IN_CLOSE_POPUP_DELAY);
        }));
        const removeCurrentPatientFromWaitingRoom = async () => {
            $timeout(async () => {
                pn.clearUserPicture();
                await pn.stop();
                pn.people.clear();
                pn.globalState = {};
                globalUi.ui.checkIn = true;
                window.history.pushState(null, null, window.location.origin + window.location.pathname);
                globalUi.ui.patientCheckIn = true;
                $state.reload();
            });
            activeComponents.chat.reset();
        };
        scopeListeners.push($rootScope.$on(RootScopeEvents.REMOVE_CURRENT_PATIENT_FROM_WAITING_ROOM, removeCurrentPatientFromWaitingRoom));
        const onRealtimeAccessDenied = () => {
            if (!VideoProviderFactory.activeProvider.isInCall) {
                removeCurrentPatientFromWaitingRoom();
                return;
            }
            const sdUnsubscribe = $rootScope.$on(RootScopeEvents.ACTIVE_PROVIDER.SESSION_DISCONNECTED, () => {
                removeCurrentPatientFromWaitingRoom();
                sdUnsubscribe();
            });
        };
        pn.on(PnEvents.AccessDenied, onRealtimeAccessDenied);
        // TELECONCENT PAGES
        scopeListeners.push($rootScope.$on('tcPagedDocument', (_event, document) => {
            checkSidebarHidden();
            this.tcPagedDocument = document;
        }));
        scopeListeners.push($rootScope.$on('tcPagedDocument:clear', () => {
            this.tcPagedDocument = null;
            if (VideoProviderFactory.activeProvider.isInCall) {
                $timeout(() => {
                    globalUi.ui.sidebarHidden = true;
                });
            }
        }));
        versionCheckService.start();
        this.$onDestroy = async () => {
            versionCheckService.stop();
            await pn.stop();
            if (this.modal)
                this.modal.hide();
            scopeListeners.map((unsubscribe) => unsubscribe());
            pn.off(PnEvents.AccessDenied, onRealtimeAccessDenied);
            this.unsubscribeFromStore();
        };
        let trackInterpreterStatusInterval = null;
        const trackInterpreterStatus = () => {
            const token = new URLSearchParams(location.search).get('token');
            if (token === null) {
                if (trackInterpreterStatusInterval !== null) {
                    clearInterval(trackInterpreterStatusInterval);
                    trackInterpreterStatusInterval = null;
                }
                return;
            }
            const roomId = this.room?.id;
            const name = this.pn.globalState?.username;
            let status = '';
            if (this.pn.globalState?.checkedInAt === undefined) {
                status = 'check-in';
            }
            else if (this.pn.globalState.status !== 'available') {
                status = 'on-call';
            }
            else {
                status = 'in-waiting-room';
            }
            VoyceService.trackInterpreterStatus(token, status, roomId, name);
        };
        if (new URLSearchParams(location.search).get('pid') === 'voyce') {
            trackInterpreterStatus();
            trackInterpreterStatusInterval = setInterval(() => {
                trackInterpreterStatus();
            }, 10000);
        }
    },
}).name;
